module.exports = __webpack_public_path__ + "img/shop.da54859c.svg";